import { filterBy } from "@progress/kendo-data-query";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import * as React from "react";

/**
 *
 * @typedef RowRadioButtonsGroupProps
 * @prop {import("../../types/customTypes").EvetHayirType} value
 * @prop {string} label
 * @prop {boolean} required
 * @prop {RadioValue[]} [values]
 */

/**
 * @typedef RadioValue
 * @prop {string} value
 * @prop {string} text
 */

const defaultValues = [
  { value: "EVET", text: "yes" },
  { value: "HAYIR", text: "no" },
];

/**
 *
 * @param {import("@progress/kendo-react-dropdowns").DropDownListProps} props
 * @returns
 */
export default function DropDownEnum(props) {
  const [filter, setFilter] = React.useState(null);
  const { enums, label } = props;
  const [e, setE] = React.useState(false);
  const values = React.useMemo(() => {
    if (enums) {
      let list = [];
      if (typeof enums[0] === "string") {
        list = enums;
        setE(false);
      } else if (Array.isArray(enums)) {
        list = enums;
        setE(false);
      } else {
        list = Object.keys(enums).map((k) => ({
          text: k,
          value: enums[k],
        }));
        setE(true);
      }
      if (filter) return filterBy(list, filter);
      return list;
    }
    return defaultValues;
  }, [enums, filter]);
  const value = React.useMemo(() => {
    return values.find((d) =>
      props.dataItemKey
        ? d[props.dataItemKey] === props.value
        : d === props.value
    );
  }, [props.value, values, props.dataItemKey]);

  return (
    <DropDownList
      {...props}
      value={value}
      data={values}
      label={props.required ? `${label} *` : label}
      textField={e ? "value" : props.textField}
      dataItemKey={e ? "text" : props.dataItemKey}
      onFilterChange={(e) => {
        setFilter(e.filter);
      }}
      onChange={(e) => {
        props.onChange(e);
      }}
    />
  );
}
